// Sidebar.jsx now forwards to SidebarNew.jsx
import SidebarNew from './SidebarNew';
export default SidebarNew;
